import { SliderImages } from 'components/common/Slider/Slider';

const convertToValidImagePath = (photo: string | null, module: string, broker?: boolean) => {
    const partUrl = broker ? 'v2/broker-offer/photo' : 'image';

    return photo?.includes('http') ? photo : `${process.env.REACT_APP_API_URL}${partUrl}/find?module=${module}&fileName=${photo}&photoSize=PHOTO_SIZE`;
};
export const convertToThumbnailPath = (photo: string, module: string, broker?: boolean) => convertToValidImagePath(photo, module, broker).replace('PHOTO_SIZE', 'NORMAL_PHOTO');

export const createImagesForSlider = (images: string[], module: string, broker?: boolean): SliderImages[] | undefined => {
    return images.length > 0 ? images.map((photo) => ({ url: convertToValidImagePath(photo, module, broker) })) : undefined;
};

